import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserDetailsComponent } from 'src/app/users/user-details/user-details.component';
import { DeletionConfirmationService } from 'src/app/util/confirmation/confirmation.service';
import { STORE_SERVICE_TOKEN } from 'src/app/util/store.service';
import { UserDataService } from 'src/app/util/user-data.service';
import { User } from '../../../models/user';
import { UsersService } from '../../../users/users.service';
import {
  DefaultEntityListStore,
  EntityListComponent,
  defaultEntityListStoreProvider,
} from '../../../util/entity-list/entity-list.base';
import { EventsServiceManager } from '../../../util/events.service';

const DIALOG_CONFIG: MatDialogConfig = {
  minWidth: '375px',
};

class UserDeletionConfirmer extends DeletionConfirmationService<User> {
  getConfirmDeleteEntityMessage(user: User): string {
    return `Are you sure you want to delete user '${user.name}'?`;
  }

  getEntityDeletedMessage(user: User): string {
    return `User ${user.name} deleted`;
  }
}

@Component({
  selector: 'app-organization-users',
  templateUrl: './organization-users.component.html',
  styleUrls: ['./organization-users.component.scss'],
  providers: [defaultEntityListStoreProvider('organization-users.component')],
})
export class OrganizationUsersComponent
  extends EntityListComponent<User, {}>
  implements OnInit, OnDestroy
{
  displayedUserColumns: string[] = [
    'email',
    'name',
    'type',
    'last_sign_in',
    'actions',
  ];

  time_zone?: string;

  constructor(
    usersService: UsersService,
    @Inject(STORE_SERVICE_TOKEN)
    store: DefaultEntityListStore,
    eventsServiceManager: EventsServiceManager,
    private dialog: MatDialog,
    private router: Router,
    private userDataService: UserDataService
  ) {
    super(
      usersService,
      store,
      new UserDeletionConfirmer(usersService, dialog, eventsServiceManager)
    );
  }

  getTableId(): string {
    return 'organization-users-table';
  }

  deleteUser(user: User) {
    this.confirmDeleteEntity(user);
    this.store.pushState(this.getState());
  }

  viewUser(user: User) {
    const userDetailsDialog = this.dialog.open(UserDetailsComponent, {
      ...DIALOG_CONFIG,
      data: {
        id: user.id,
      },
    });

    // If edit user or delete user was selected
    userDetailsDialog.afterClosed().subscribe((option?: 'delete' | 'edit') => {
      if (option === 'delete') {
        this.confirmDeleteEntity(user);
      }
      if (option === 'edit') {
        this.router.navigate(['/users', user.id, 'edit']);
      }
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.time_zone =
      this.userDataService.organization?.primary_location?.time_zone;
  }
}
